<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <Logo/>
    <a-menu
      v-if="menus.length > 0"
      :defaultSelectedKeys="defaultKey"
      :selectedKeys="currentKey"
      style="flex: 1"
      theme="dark"
      mode="inline"
    >
      <template v-for="menu in menus">
        <template v-if="menu.route">
          <a-menu-item v-if="menu.children.length === 0" :key="menu.route" @click="clickMenu(menu)">
            <template v-if="menu.icon">
              <a-icon :type="menu.icon" />
            </template>
            <a-tooltip v-if="menu.name && menu.name.length > 13">
              <template slot="title">
                {{ menu.name }}
              </template>
              {{ menu.name }}
            </a-tooltip>
            <span v-else>{{ menu.name }}</span>
          </a-menu-item>
          <a-sub-menu v-else :key="menu.route">
            <span slot="title">
              <template v-if="menu.icon">
              <a-icon :type="menu.icon" />
            </template>
              <a-tooltip v-if="menu.name && menu.name.length > 13">
                <template slot="title">
                  {{ menu.name }}
                </template>
                {{ menu.name }}
              </a-tooltip>
              <span v-else>{{ menu.name }}</span>
            </span>
            <a-menu-item v-for="item in menu.children" :key="item.route" @click="clickMenu(item)">
              <template v-if="item.icon">
                <a-icon :type="item.icon" />
              </template>
              <a-tooltip v-if="item.name && item.name.length > 13">
                <template slot="title">
                  {{ item.name }}
                </template>
                {{ item.name }}
              </a-tooltip>
              <span v-else>{{ item.name }}</span>
            </a-menu-item>
          </a-sub-menu>
        </template>
      </template>
    </a-menu>
  </div>
</template>

<script>
import Logo from './Logo'
export default {
  name: 'SiderMenu',
  components: { Logo },
  props: {
    menus: {
      type: Array,
      default: []
    }
  },
  created () {
    const lang = localStorage.getItem('lang')
    if (lang === 'en') {
      this.lang = 'en-US'
    } else {
      this.lang = 'zh-CN'
    }
  },
  mounted () {
    // const index = this.menus.findIndex(m => m.routeName === 'Overview')
    // console.log(index);
    // const route = this.menus.splice(index, 1)
    // console.log(route);
    // this.menus.unshift(route[0])
    // else {
    //   this.menus = this.$store.getters.menus
    //   this.defaultKey[0] = this.menus[0].route
    //   const path = (this.$store.state.routePath === '/equipment/group' || this.$store.state.routePath === '/customerMaintain') ? this.$store.state.routePath : '/overview'
    //   this.$router.push({ path })
    //   this.$store.commit('setRoutePath', '')
    // }
    this.menus.forEach(m => {
      m.name = m.details.find(d => d.locale === this.lang).name
      if (m.children?.length) {
        if (m.routeName === "Warning") {
          const children = []
          const order = m.children.find(c => c.routeName === "WarningOrder")
          if (order) {
            order.name = order.details.find(dd => dd.locale === this.lang).name
            children[0] = order
          }
          children.unshift({
            route: "/warning",
            icon: "menu",
            name: this.lang === "en-US" ? "Warning List" : "预警列表"
          })
          m.children = children
        } else {
          m.children.forEach(c => {
            c.name = c.details.find(dd => dd.locale === this.lang).name
          })
        }
      }
    })
    this.$forceUpdate()
  },
  watch: {
    locale(value) {
      this.lang = value === 'en' ? 'en-US' : 'zh-CN'
      this.menus.forEach(m => {
        m.name = m.details.find(d => d.locale === this.lang).name
        if (m.children?.length) {
          if (m.routeName === "Warning") {
            const children = []
            const order = m.children.find(c => c.routeName === "WarningOrder")
            if (order) {
              order.name = order.details.find(dd => dd.locale === this.lang).name
              children[0] = order
            }
            children.unshift({
              route: "/warning",
              icon: "menu",
              name: value === "en" ? "Warning List" : "预警列表"
            })
            m.children = children
          } else {
            m.children.forEach(c => {
              c.name = c.details.find(dd => dd.locale === this.lang).name
            })
          }
        }
      })
      this.$forceUpdate()
    }
  },
  data () {
    return {
      defaultKey: [],
      lang: ''
    }
  },
  computed: {
    currentKey () {
      return [this.$route.path.startsWith('/overview') ? '/overview' : this.$route.path]
    },
    locale() {
      return this.$store.state.lang
    }
  },
  methods: {
    clickMenu (item) {
      sessionStorage.setItem('authorities', JSON.stringify(item.authorities))
      if (!item.route.startsWith('/warning') || item.route === '/warning') {
        console.log(item);
        this.$store.commit('ADD_VISITED_VIEW', item)
      }
      this.$router.push(item.route)
    }
  }
}
</script>

<style scoped>

</style>
